import { createI18n } from 'vue-i18n';

const modules = import.meta.glob<Record<string, unknown>>('./en/*.json', { eager: true });

const en: Record<string, unknown> = {};

for (const path in modules) {
    const key = path.replace('./en/', '').replace('.json', '');
    en[key] = (modules[path] as { default: unknown }).default;
}

type MessageSchema = typeof en;

export default createI18n<[MessageSchema], 'en'>({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en,
    },
});
